import { Action } from '@ngrx/store';
import { TechnicalError } from '@dch/products-business-logic';

export const GET_NSP_PRODUCTS_IN_PACK = 'GET_NSP_PRODUCTS_IN_PACK';
export const GET_NSP_PRODUCTS_IN_PACK_SUCCESS =
  'GET_NSP_PRODUCTS_IN_PACK_SUCCESS';
export const GET_NSP_PRODUCTS_IN_PACK_FAILED =
  'GET_NSP_PRODUCTS_IN_PACK_FAILED';

export const GET_NSP_STANDALONE_PRODUCTS = 'GET_NSP_STANDALONE_PRODUCTS';
export const GET_NSP_STANDALONE_PRODUCTS_SUCCESS =
  'GET_NSP_STANDALONE_PRODUCTS_SUCCESS';
export const GET_NSP_STANDALONE_PRODUCTS_FAILED =
  'GET_NSP_STANDALONE_PRODUCTS_FAILED';

export const GET_NSP_STATISTICS_PRODUCTS = 'GET_NSP_STATISTICS_PRODUCTS';
export const GET_NSP_STATISTICS_PRODUCTS_SUCCESS =
  'GET_NSP_STATISTICS_PRODUCTS_SUCCESS';
export const GET_NSP_STATISTICS_PRODUCTS_FAILED =
  'GET_NSP_STATISTICS_PRODUCTS_FAILED';

export const UPDATE_INTERNET_NSP_VALUES = 'UPDATE_INTERNET_NSP_VALUES';
export const UPDATE_MOBILE_NSP_VALUES = 'UPDATE_MOBILE_NSP_VALUES';

export class GetNspProductsInPack implements Action {
  type = GET_NSP_PRODUCTS_IN_PACK;

  constructor(public payload?: any) {}
}

export class GetNspProductsInPackSuccess implements Action {
  type = GET_NSP_PRODUCTS_IN_PACK_SUCCESS;

  constructor(public payload: any) {}
}

export class GetNspProductsInPackFailed implements Action {
  type = GET_NSP_PRODUCTS_IN_PACK_FAILED;

  constructor(public payload: TechnicalError) {}
}

export class GetNspStandaloneProducts implements Action {
  type = GET_NSP_STANDALONE_PRODUCTS;

  constructor(public payload?: any) {}
}

export class GetNspStandaloneProductsSuccess implements Action {
  type = GET_NSP_STANDALONE_PRODUCTS_SUCCESS;

  constructor(public payload: any) {}
}

export class GetNspStandaloneProductsFailed implements Action {
  type = GET_NSP_STANDALONE_PRODUCTS_FAILED;

  constructor(public payload: TechnicalError) {}
}

export class GetNspStatisticsProducts implements Action {
  type = GET_NSP_STATISTICS_PRODUCTS;

  constructor(public payload?: any) {}
}

export class GetNspStatisticsProductsSuccess implements Action {
  type = GET_NSP_STATISTICS_PRODUCTS_SUCCESS;

  constructor(public payload: any) {}
}

export class GetNspStatisticsProductsFailed implements Action {
  type = GET_NSP_STATISTICS_PRODUCTS_FAILED;

  constructor(public payload: TechnicalError) {}
}

export class UpdateInternetNspValues implements Action {
  type = UPDATE_INTERNET_NSP_VALUES;

  constructor(public payload?: any) {}
}

export class UpdateMobileNspValues implements Action {
  type = UPDATE_MOBILE_NSP_VALUES;

  constructor(public payload?: any) {}
}

export type Actions =
  | GetNspProductsInPack
  | GetNspProductsInPackSuccess
  | GetNspProductsInPackFailed
  | GetNspStandaloneProducts
  | GetNspStandaloneProductsSuccess
  | GetNspStandaloneProductsFailed
  | UpdateInternetNspValues
  | UpdateMobileNspValues;
